import React from 'react';
import { getDateObj, getLargeDate } from '../../../utils';
import Comments from '../../layout/comments/comments.component';

interface InfoDateProps {
    dates: {
        date: string,
        ipuDate: string
    },
    localLevel?: boolean,
}

const InfoDate: React.FC<InfoDateProps> = ({
    dates,
    localLevel = false,
}) => (
    <Comments>
        { dates.date && (
            <p><strong>Last updated: { getLargeDate(getDateObj(dates.date).getTime()) }.</strong></p>
        ) }
        { dates.ipuDate && (
            <p>
                {
                    localLevel
                    ? (
                        <strong>
                            Data source for women’s representation: Data compiled by UN Women
                            (the custodian agency for SDG indicator 5.5.1b)
                            in partnership with UN Regional Commissions.
                            As of { getLargeDate(getDateObj((() => {
                                const [year, month, day] = dates.ipuDate.split('-').map(Number);

                                if (year === 2026 && month === 1 && day === 1) {
                                    return "2025-1-1";
                                }

                                return dates.ipuDate;
                            })()).getTime()) }.
                        </strong>
                    )
                    : (
                        <strong>
                            Data source for women’s representation: Inter-Parliamentary Union.
                            As of { getLargeDate(getDateObj(dates.ipuDate).getTime()) }.
                        </strong>
                    )
                }
            </p>
        ) }
    </Comments>
);

export default InfoDate;
